// extracted by mini-css-extract-plugin
module.exports = {"tooltip":"yKZxyUaJ","bubble":"zBGUEhIX"};